import { httpCreate } from './http';

const http = httpCreate('/srv/vote');

export const vote = {
	addVote(data) {
		return http.post('/add', data);
	},
	// pageNum, pageSize, activityId
	getVote(params) {
		return http.get('/list', { params });
	},
	delVote(ids) {
		return http.post('/delete', ids);
	},
	editVote(data) {
		return http.post('/update', data);
	},
	copyVote(id, data) {
		return http.post(`/copy/${id}`, data);
	},
	delVoteOption(id) {
		return http.get(`/deleteOption/${id}`);
	},
	getVoteDetail(id) {
		return http.get(`/detail/?voteId=${id}`);
	},
	// 获取投票项详情
	getItemDetail(id) {
		return http.get(`/options/getOption/${id}`);
	},
	// 获取投票项列表
	getVoteItem(id, params) {
		return http.get(`/options/list/${id}`, { params });
	},
	// 添加投票项
	addItem(data) {
		return http.post('options/add', data);
	},
	// 编辑投票项
	editItem(data) {
		return http.post('/options/update', data);
	},
	// 删除投票项
	delItem(ids) {
		return http.post('/options/delete', ids);
	},
	// 用户投票列表
	userList(id, params) {
		return http.get(`/user/list/${id}`, { params });
	},
	// 导入文字投票项
	importList(id, data) {
		return http.post(`/options/import/${id}`, data);
	},
	// 导出模板
	downloadTemplate() {
		return http.get('/options/downloadTemplate');
	},
	// 修改用户投票数量
	updateCount(id, count) {
		return http.post(`/user/updateCount/${id}?count=${count}`);
	},
	// 排行榜
	topList(id, params) {
		return http.get(`/options/topList/${id}`, { params });
	},
	// 发起或隐藏投票
	changeOpen(id, isOpen) {
		return http.post(`/changeOpen/${id}?isOpen=${isOpen}`);
	},
	// 立即开始投票
	openVote(voteId, status) {
		return http.post(`/${voteId}/switch/${status}`);
	},
	// 获取所有投票项列表
	getAllVoteItemList(activityId, params) {
		return http.get(`/options/allList/${activityId}`, { params });
	},
	// 获取所有投票（用户下拉列表）
	getAllVote(activityId) {
		return http.get(`/all/${activityId}`);
	},
	// 投票项投票详情
	getVoteItemDetail(optionId, params) {
		return http.get(`/user/option/${optionId}`, { params });
	},
};
